export enum EMMA_COLORS {
  BRAND = '#00a263',
  METAL = '#c4c5d6',
  LIGHT = '#ffffff',
  ACCENT = '#00c5dc',
  PRIMARY = '#5867dd',
  SUCCESS = '#34bfa3',
  INFO = '#36a3f7',
  WARNING = '#ffb822',
  DANGER = '#f4516c',
  EMMAGREEN = '#00a263',
  EMMABLUE = '#12849f',
  EMMADARKBLUE = '#0a2c33',
  ALTGREEN = '#01e08a',
  ALTPINK = '#ff1981',
  ALTBLUE = '#18b4d9',
  ALTORANGE = '#ffc778',
  ALTYELLOW = '#ffea76',
  ALTVIOLET = '#b678fe',
  ALTDARKBLUE = '#11515e',
  ALTSOFTORANGE = '#ffc778',
}
